import axios from "axios";
import { del, get, post, put, patch } from "./api_helper";
import * as url from "./url_helper";

// Gets the logged in user data from local session
const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

//is user is logged in
const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

// Register Method
const postFakeRegister = data => {
  return axios
    .post(url.POST_FAKE_REGISTER, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data;
      throw response.data;
    })
    .catch(err => {
      let message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};

// Login Method

// postForgetPwd
const postFakeForgetPwd = data => post(url.POST_FAKE_PASSWORD_FORGET, data);

// Edit profile
const postJwtProfile = data => post(url.POST_EDIT_JWT_PROFILE, data);

const postFakeProfile = data => post(url.POST_EDIT_PROFILE, data);

// Register Method
const postJwtRegister = (url, data) => {
  return axios
    .post(url, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data;
      throw response.data;
    })
    .catch(err => {
      var message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};

// Login Method
const postJwtLogin = data => post(url.POST_FAKE_JWT_LOGIN, data);

// postForgetPwd
const postJwtForgetPwd = data => post(url.POST_FAKE_JWT_PASSWORD_FORGET, data);

// postSocialLogin
export const postSocialLogin = data => post(url.SOCIAL_LOGIN, data);

// get Products
export const getProducts = () => get(url.GET_PRODUCTS);

// get Product detail
export const getProductDetail = id =>
  get(`${url.GET_PRODUCTS_DETAIL}/${id}`, { params: { id } });

// get Events

// add Events

// update Event


// delete Event
export const deleteEvent = project =>
  del(`https://adminoy.oyliyo.com.tr:9654/deleteEventMega/${project}`);


// get Categories

// get chats

// get groups
export const getGroups = () => get(url.GET_GROUPS);

// get Contacts
export const getContacts = () => get(url.GET_CONTACTS);

// get messages


// post messages
export const getselectedmails = (selectedmails) => post(url.GET_SELECTED_MAILS, selectedmails);

//post setfolderonmails
export const setfolderonmails = (selectedmails, folderId, activeTab) => post(url.SET_FOLDER_SELECTED_MAILS, { selectedmails, folderId, activeTab });

// get orders
export const getOrders = () => get(url.GET_ORDERS);

// add order
export const addNewOrder = order => post(url.ADD_NEW_ORDER, order);

// update order
export const updateOrder = order => put(url.UPDATE_ORDER, order);

// delete order
export const deleteOrder = order =>
  del(url.DELETE_ORDER, { headers: { order } });

// get cart data
export const getCartData = () => get(url.GET_CART_DATA);

// get customers
export const getCustomers = () => get(url.GET_CUSTOMERS);

// add CUSTOMER
export const addNewCustomer = customer => post(url.ADD_NEW_CUSTOMER, customer);

// update CUSTOMER
export const updateCustomer = customer => put(url.UPDATE_CUSTOMER, customer);

// delete CUSTOMER
export const deleteCustomer = customer =>
  del(url.DELETE_CUSTOMER, { headers: { customer } });

// get shops
export const getShops = () => get(url.GET_SHOPS);

// get wallet
export const getWallet = () => get(url.GET_WALLET);

// get crypto order
export const getCryptoOrder = () => get(url.GET_CRYPTO_ORDERS);

// get crypto product
export const getCryptoProduct = () => get(url.GET_CRYPTO_PRODUCTS);

// get invoices
export const getInvoices = () => get(url.GET_INVOICES);

// get invoice details
export const getInvoiceDetail = id =>
  get(`${url.GET_INVOICE_DETAIL}/${id}`, { params: { id } });

// get jobs
export const getJobList = () => get(url.GET_JOB_LIST);

// get Apply Jobs
export const getApplyJob = () => get(url.GET_APPLY_JOB);

// get project
export const getProjects = () => get(url.GET_PROJECTS);

// get project details
export const getProjectsDetails = id =>
  get(`${url.GET_PROJECT_DETAIL}/${id}`, { params: { id } });

// get tasks
export const getTasks = () => get(url.GET_TASKS);



export const getArticleDay= () => get(`https://adminoy.oyliyo.com.tr:9654/getArticleDayBerlin/select/`);
export const addArticleDay = job => post(`https://adminoy.oyliyo.com.tr:9654/addArticleDayBerlin/send`, job);
export const updateArticleDay = user => patch(`https://adminoy.oyliyo.com.tr:9654/updateArticleDayBerlin/${user.ID}`, user);
export const deleteArticleDay= user => del(`https://adminoy.oyliyo.com.tr:9654/deleteArticleDayBerlin/${user}`);


export const getNews_Category= () => get(`https://adminoy.oyliyo.com.tr:9654/getPollComment/select/`);
export const addNews_Category = job => post(`https://adminoy.oyliyo.com.tr:9654/addPollComment/send`, job);
export const updateNews_Category = user => patch(`https://adminoy.oyliyo.com.tr:9654/updatePollComment/${user.ID}`, user);
export const deleteNews_Category= user => del(`https://adminoy.oyliyo.com.tr:9654/deletePollComment/${user}`);


export const getSongCategory= () => get(`https://adminoy.oyliyo.com.tr:9654/getSong_CategoryBerlin/select/`);
export const addSongCategory = job => post(`https://adminoy.oyliyo.com.tr:9654/addSong_CategoryBerlin/send`, job);
export const updateSongCategory = user => patch(`https://adminoy.oyliyo.com.tr:9654/updateSong_CategoryBerlin/${user.ID}`, user);
export const deleteSongCategory= user => del(`https://adminoy.oyliyo.com.tr:9654/deleteSong_CategoryBerlin/${user}`);



export const addNews = job => post(`https://adminoy.oyliyo.com.tr:9654/addNewsBerlin/send`, job);
export const updateNews = user => patch(`https://adminoy.oyliyo.com.tr:9654/updateNewsBerlin/${user.ID}`, user);
export const deleteNews = user => del(`https://adminoy.oyliyo.com.tr:9654/deleteNewsBerlin/${user}`);

export const getNe= () => get(`https://adminoy.oyliyo.com.tr:9654/getBlogRehber/select/`);
export const addNe = job => post(`https://adminoy.oyliyo.com.tr:9654/addBlogRehber/send`, job);
export const updateNe = user => patch(`https://adminoy.oyliyo.com.tr:9654/updateBlogRehber/${user.ID}`, user);
export const deleteNe = user => del(`https://adminoy.oyliyo.com.tr:9654/deleteBlogRehber/${user}`);



export const getNews_Comment= () => get(`https://adminoy.oyliyo.com.tr:9654/getNews_CommentBerlin/select/`);
export const deleteNews_Comment = user => del(`https://adminoy.oyliyo.com.tr:9654/deleteNews_CommentBerlin/${user}`);
export const addForum = job => post(`https://adminoy.oyliyo.com.tr:9654/addDoctorCategory/send`, job);




export const getPool= () => get(`https://adminoy.oyliyo.com.tr:9654/getPoolBerlin/select/`);
export const addPool = job => post(`https://adminoy.oyliyo.com.tr:9654/addPoolBerlin/send`, job);
export const updatePool = user => patch(`https://adminoy.oyliyo.com.tr:9654/updatePoolBerlin/${user.ID}`, user);
export const deletePool = user => del(`https://adminoy.oyliyo.com.tr:9654/deletePoolBerlin/${user}`);

export const getNews= () => get(`https://adminoy.oyliyo.com.tr:9654/getBlogRehber/select/`);
export const updateAbout = user => patch(`https://adminoy.oyliyo.com.tr:9654/updatePollAbout/${user.ID}`, user);
export const getAbout = () => get(`https://adminoy.oyliyo.com.tr:9654/getPollAbout/select/`);
export const getAbout2 = () => get(`https://adminoy.oyliyo.com.tr:9654/getReferancesRehber/select/`);
export const updateAbout2 = user => patch(`https://adminoy.oyliyo.com.tr:9654/updateReferancesRehber/${user.ID}`, user);

export const getFeedBack = () => get(`https://adminoy.oyliyo.com.tr:9654/getFeedBack/select/`);
export const updateFeedBack = user => patch(`https://adminoy.oyliyo.com.tr:9654/updateFeedBack/${user.ID}`, user);
export const addFeedBack= job => post(`https://adminoy.oyliyo.com.tr:9654/addFeedBack/send`, job);
export const deleteFeedBack= project =>
del(`https://adminoy.oyliyo.com.tr:9654/deleteFeedBack/${project}`);

export const getDynamicForm2 = () => get(`https://adminoy.oyliyo.com.tr:9654/getPollInAppOption/select/`);
export const updateDynamicForm2 = user => patch(`https://adminoy.oyliyo.com.tr:9654/updatePollInAppOption/${user.ID}`, user);
export const addDynamicForm2= job => post(`https://adminoy.oyliyo.com.tr:9654/addPollInAppOption/send`, job);
export const deleteDynamicForm2= project =>
del(`https://adminoy.oyliyo.com.tr:9654/deletePollInAppOption/${project}`);



export const getUsers = () => get(`https://adminoy.oyliyo.com.tr:9654/getPollUsers/select/`);
export const addUser = job => post(`https://adminoy.oyliyo.com.tr:9654/addPollUsers/send`, job);
export const updateUser = user => patch(`https://adminoy.oyliyo.com.tr:9654/updatePollUsers/${user.ID}`, user);
export const deleteUser = user => del(`https://adminoy.oyliyo.com.tr:9654/deletePollUsers/${user}`);


export const getSong= () => get(`https://adminoy.oyliyo.com.tr:9654/getPollCategory/select/`);
export const addSong = job => post(`https://adminoy.oyliyo.com.tr:9654/addPollCategory/send`, job);
export const updateSong = user => patch(`https://adminoy.oyliyo.com.tr:9654/updatePollCategory/${user.ID}`, user);
export const deleteSong = user => del(`https://adminoy.oyliyo.com.tr:9654/deletePollCategory/${user}`);

export const getSliders = () => get(`https://adminoy.oyliyo.com.tr:9654/getPoll/select/`);
export const updateSlider = user => patch(`https://adminoy.oyliyo.com.tr:9654/updatePoll/${user.ID}`, user);
export const deleteSlider = project =>
  del(`https://adminoy.oyliyo.com.tr:9654/deletePoll/${project}`);
  export const addSlider = job => post(`https://adminoy.oyliyo.com.tr:9654/addPoll/send`, job);




  export const getAdvertesing_Category = () => get(`https://adminoy.oyliyo.com.tr:9654/getAdvertesing_CategoryBerlin/select/`);
  export const updateAdvertesing_Category = user => patch(`https://adminoy.oyliyo.com.tr:9654/updateAdvertesing_CategoryBerlin/${user.ID}`, user);
  export const deleteAdvertesing_Category = project =>
    del(`https://adminoy.oyliyo.com.tr:9654/deleteAdvertesing_CategoryBerlin/${project}`);
    export const addAdvertesing_Category = job => post(`https://adminoy.oyliyo.com.tr:9654/addAdvertesing_CategoryBerlin/send`, job);
  
  


  export const getAdvertesing_Form = () => get(`https://adminoy.oyliyo.com.tr:9654/getAdvertesing_FormBerlin/select/`);
  export const updateAdvertesing_Form = user => patch(`https://adminoy.oyliyo.com.tr:9654/updateAdvertesing_FormBerlin/${user.ID}`, user);
  export const deleteAdvertesing_Form = project =>
    del(`https://adminoy.oyliyo.com.tr:9654/deleteAdvertesing_FormBerlin/${project}`);
    export const addAdvertesing_Form = job => post(`https://adminoy.oyliyo.com.tr:9654/addAdvertesing_FormBerlin/send`, job);
  
  

    export const getJob_Advertisement_Category = () => get(`https://adminoy.oyliyo.com.tr:9654/getJob_Advertisement_CategoryBerlin/select/`);
    export const updateJob_Advertisement_Category = user => patch(`https://adminoy.oyliyo.com.tr:9654/updateJob_Advertisement_CategoryBerlin/${user.ID}`, user);
    export const deleteJob_Advertisement_Category = project =>
      del(`https://adminoy.oyliyo.com.tr:9654/deleteJob_Advertisement_CategoryBerlin/${project}`);
      export const addJob_Advertisement_Category = job => post(`https://adminoy.oyliyo.com.tr:9654/addJob_Advertisement_CategoryBerlin/send`, job);
    
    



      export const getJob_Advertisement_SubCategory = () => get(`https://adminoy.oyliyo.com.tr:9654/getDoctorList/select/`);
      export const updateJob_Advertisement_SubCategory = user => patch(`https://adminoy.oyliyo.com.tr:9654/updateDoctorList/${user.ID}`, user);
      export const deleteJob_Advertisement_SubCategory = project =>
        del(`https://adminoy.oyliyo.com.tr:9654/deleteDoctorList/${project}`);
        export const addJob_Advertisement_SubCategory = job => post(`https://adminoy.oyliyo.com.tr:9654/addDoctorList/send`, job);
      
      

  
      export const getJob_Advertisement = () => get(`https://adminoy.oyliyo.com.tr:9654/getJob_AdvertisementBerlin/select/`);
      export const deleteJob_Advertisement = project =>
        del(`https://adminoy.oyliyo.com.tr:9654/deleteJob_AdvertisementBerlin/${project}`);
     
  

        export const getForum = () => get(`https://adminoy.oyliyo.com.tr:9654/getPollComplatedInAppOption/select/`);
        export const updateForum = user => patch(`https://adminoy.oyliyo.com.tr:9654/updateDoctorCategory/${user.ID}`, user);
        export const deleteForum = project =>
          del(`https://adminoy.oyliyo.com.tr:9654/deleteDoctorCategory/${project}`);
    
  export const getSubEducation = () => get(`https://adminoy.oyliyo.com.tr:9654/getSlidersBerlin/select/`);
  export const updateSubEducation = user => patch(`https://adminoy.oyliyo.com.tr:9654/updateSlidersBerlin/${user.ID}`, user);
  export const deleteSubEducation = project =>
    del(`https://adminoy.oyliyo.com.tr:9654/deleteSlidersBerlin/${project}`);
    export const addSubEducation= job => post(`https://adminoy.oyliyo.com.tr:9654/addSlidersBerlin/send`, job);
  

  export const getCompany_Category = () => get(`https://adminoy.oyliyo.com.tr:9654/getCompany_CategoryBerlin/select/`);
export const updateCompany_Category = user => patch(`https://adminoy.oyliyo.com.tr:9654/updateCompany_CategoryBerlin/${user.ID}`, user);
export const deleteCompany_Category = project =>
  del(`https://adminoy.oyliyo.com.tr:9654/deleteCompany_CategoryBerlin/${project}`);
  export const addCompany_Category = job => post(`https://adminoy.oyliyo.com.tr:9654/addCompany_CategoryBerlin/send`, job);


export const getCompany_SubCategory = () => get(`https://adminoy.oyliyo.com.tr:9654/getPollAdvert/select/`);
export const updateCompany_SubCategory = user => patch(`https://adminoy.oyliyo.com.tr:9654/updatePollAdvert/${user.ID}`, user);
export const deleteCompany_SubCategory = project =>
  del(`https://adminoy.oyliyo.com.tr:9654/deletePollAdvert/${project}`);
  export const addCompany_SubCategory = job => post(`https://adminoy.oyliyo.com.tr:9654/addPollAdvert/send`, job);



  export const getMainPage_Category= () => get(`https://adminoy.oyliyo.com.tr:9654/getQuestionsAnswerRange/select/`);
export const updateMainPage_Category = user => patch(`https://adminoy.oyliyo.com.tr:9654/updateQuestionsAnswerRange/${user.ID}`, user);
export const deleteMainPage_Category= project =>
  del(`https://adminoy.oyliyo.com.tr:9654/deleteQuestionsAnswerRange/${project}`);
  export const addMainPage_Category = job => post(`https://adminoy.oyliyo.com.tr:9654/addQuestionsAnswerRange/send`, job);





  export const getCompany_Advert_Price = () => get(`https://adminoy.oyliyo.com.tr:9654/getCompany_Advert_PriceBerlin/select/`);
  export const updateCompany_Advert_Price= user => patch(`https://adminoy.oyliyo.com.tr:9654/updateCompany_Advert_PriceBerlin/${user.ID}`, user);
  export const deleteCompany_Advert_Price = project =>
    del(`https://adminoy.oyliyo.com.tr:9654/deleteCompany_Advert_PriceBerlin/${project}`);
    export const addCompany_Advert_Price = job => post(`https://adminoy.oyliyo.com.tr:9654/addCompany_Advert_PriceBerlin/send`, job);
  

export const getCompany = () => get(`https://adminoy.oyliyo.com.tr:9654/getCompanyBerlin/select/`);
export const addCompany  = user => post(`https://adminoy.oyliyo.com.tr:9654/addCompanyBerlin/send`, user);
export const updateCompany  = user => patch(`https://adminoy.oyliyo.com.tr:9654/updateCompanyBerlin/${user.ID}`, user);
export const deleteCompany  = user => del(`https://adminoy.oyliyo.com.tr:9654/deleteCompanyBerlin/${user}`);


export const addEducation = user => post(`https://adminoy.oyliyo.com.tr:9654/addEducationNefes/send`, user);
export const addProductCategory = user => post(`https://adminoy.oyliyo.com.tr:9654/addProductsCategoryLuxun/send`, user);
export const deleteProductCategory = user => del(`https://adminoy.oyliyo.com.tr:9654/deleteProductCategoryLuxun/${user}`);
export const updateProductCategory = user => patch(`https://adminoy.oyliyo.com.tr:9654/updateProductCategoryLuxun/${user.ID}`, user);

export const updateEducation = user => patch(`https://adminoy.oyliyo.com.tr:9654/updateEducationNefes/${user.ID}`, user);

export const updateContact = user => patch(`https://adminoy.oyliyo.com.tr:9654/updateContactCastor/${user.ID}`, user);
export const getCategory = () => get(`https://adminoy.oyliyo.com.tr:9654/getProductsCategoryLuxun/select/`);
export const getProducts1 = () => get(`https://adminoy.oyliyo.com.tr:9654/getProductsLuxun/select/`);

export const getSSS = () => get(`https://adminoy.oyliyo.com.tr:9654/getSSSPort/select/`);
export const getBlogs = () => get(`https://adminoy.oyliyo.com.tr:9654/getBlogCastor/select/`);

export const addNewUser = user => post(`https://adminoy.oyliyo.com.tr:9654/postForumBerlin/send`, user);

export const getProjectsNew = () => get(`https://adminoy.oyliyo.com.tr:9654/getEducationNefes/select/`);
export const getEducation = () => get(`https://adminoy.oyliyo.com.tr:9654/getEducationNefes/select/`);
export const getEducationSubItem = () => get(`https://adminoy.oyliyo.com.tr:9654/getEducationSubItemNefes/select/`);
export const getWorkShop = () => get(`https://adminoy.oyliyo.com.tr:9654/getSUBDOMAINMega/select/`);

export const getCourseSchedulesMega = () => get(`https://adminoy.oyliyo.com.tr:9654/getCourseSchedulesMega/select/`);

export const getWorkshopSessionMega = () => get(`https://adminoy.oyliyo.com.tr:9654/getWorkshopSessionMega/select/`);

export const getTeacherMega = () => get(`https://adminoy.oyliyo.com.tr:9654/getTeacherMega/select/`);

export const getEventMega = () => get(`https://adminoy.oyliyo.com.tr:9654/getEventMega/select/`);

export const getDynamicFormMega = () => get(`https://adminoy.oyliyo.com.tr:9654/getPollInAppOption/select/`);
export const updateDynamicForm = user => patch(`https://adminoy.oyliyo.com.tr:9654/updatePollInAppOption/${user.ID}`, user);
export const addDynamicForm = job => post(`https://adminoy.oyliyo.com.tr:9654/addPollInAppOption/send`, job);
export const deleteDynamicForm = project =>
  del(`https://adminoy.oyliyo.com.tr:9654/deletePollInAppOption/${project}`);
const postFakeLogin = data => get(`https://adminoy.oyliyo.com.tr:9654/getUserLoginRehber/select/${data.email}/${data.password}`,);


export const getMegaMega = () => get(`https://adminoy.oyliyo.com.tr:9654/getMegaMega/select/`);

export const getMailsLists = () => get(`https://adminoy.oyliyo.com.tr:9654/getContactMessageMega/select/`);

// add user

export const getEvents = () => get(`https://adminoy.oyliyo.com.tr:9654/getEventMega/select/`);
export const getCategories = () => get(`https://adminoy.oyliyo.com.tr:9654/getEventCategoryMega/select/`);


export const updateSubDomain = user => patch(`https://adminoy.oyliyo.com.tr:9654/patchSUBDOMAINMega/${user.ID}`, user);

export const updateCourseSchedules = user => patch(`https://adminoy.oyliyo.com.tr:9654/patchCourseSchedulesMega/${user.ID}`, user);

export const updateWorkshopSession = user => patch(`https://adminoy.oyliyo.com.tr:9654/patchWorkShopSessionMega/${user.ID}`, user);

export const updateTeacher = user => patch(`https://adminoy.oyliyo.com.tr:9654/patchUserMega/${user.ID}`, user);


export const updateSSS = user => patch(`https://adminoy.oyliyo.com.tr:9654/updateSSSPort/${user.ID}`, user);

export const updateProduct = user => patch(`https://adminoy.oyliyo.com.tr:9654/updateProductLuxun/${user.ID}`, user);
export const updateBlog = user => patch(`https://adminoy.oyliyo.com.tr:9654/updateBlogCastor/${user.ID}`, user);



export const updateProject = user => patch(`https://adminoy.oyliyo.com.tr:9654/patchUpdateProject/${user.ID}`, user);




export const addSSS= job => post(`https://adminoy.oyliyo.com.tr:9654/addSSSPort/send`, job);
export const addProduct = job => post(`https://adminoy.oyliyo.com.tr:9654/addProductLuxun/send`, job);

export const addBlog = job => post(`https://adminoy.oyliyo.com.tr:9654/addBlogCastor/send`, job);
export const addProject = job => post(`https://adminoy.oyliyo.com.tr:9654/addProject/send`, job);



export const addMega = job => post(`https://adminoy.oyliyo.com.tr:9654/addMega/send`, job);

export const addCourseMega = job => post(`https://adminoy.oyliyo.com.tr:9654/addCourseMega/send`, job);

export const updateSubdomain = user => patch(`https://adminoy.oyliyo.com.tr:9654/patchSUBDOMAINMega/${user.ID}`, user);



export const updateAuth = user => patch(`https://adminoy.oyliyo.com.tr:9654/patchAuthMega/${user.ID}`, user);

export const updateMega = user => patch(`https://adminoy.oyliyo.com.tr:9654/patchMegaMega/${user.ID}`, user);

export const updateGallery = user => patch(`https://adminoy.oyliyo.com.tr:9654/patchGalleryMega/${user.ID}`, user);

export const updateEvent = event => patch(`https://adminoy.oyliyo.com.tr:9654/patchEventMega/${event.ID}`, event);

export const addAppSetting = job => post(`https://adminoy.oyliyo.com.tr:9654/postWSMega/send`, job);

export const addWorkshop2 = job => post(`https://adminoy.oyliyo.com.tr:9654/postWorkshopMega/send`, job);



// delete user

export const getContact = () => get(`https://adminoy.oyliyo.com.tr:9654/getContactCastor/select/`);
export const getAuthority = () => get(`https://adminoy.oyliyo.com.tr:9654/getUsersTypeMega/select/`);
export const getWorkshop2 = () => get(`https://adminoy.oyliyo.com.tr:9654/getWorkshopMega/select/`);

export const updateWorkShop2 = user => patch(`https://adminoy.oyliyo.com.tr:9654/patchWorkshop2Mega/${user.ID}`, user);

export const getGallery = () => get(`https://adminoy.oyliyo.com.tr:9654/getGalleryMega/select/`);

export const addNewEvent = event => post(`https://adminoy.oyliyo.com.tr:9654/postEventMega/send/`, event);

export const getChats = () => get(`https://adminoy.oyliyo.com.tr:9654/getContactMessageMega/select/`);

export const getMessages = (roomId = "") => get(`https://adminoy.oyliyo.com.tr:9654/getContactMessageDetailMega/select/${roomId}`);

export const addNewSubdomain = event => post(`https://adminoy.oyliyo.com.tr:9654/postSubdomainMega/send/`, event);
export const getReferances = () => get(`https://adminoy.oyliyo.com.tr:9654/getReferancesMega/select/`);
// add jobs
export const addNewJobList = job => post(url.ADD_NEW_JOB_LIST, job);
// update jobs
export const updateJobList = job => put(url.UPDATE_JOB_LIST, job);
// delete jobs
export const deleteJobList = job => del(url.DELETE_JOB_LIST, { headers: { job } });
// Delete Apply Jobs
export const deleteApplyJob = data => del(url.DELETE_APPLY_JOB, { headers: { data } });
/** PROJECT */
// add user
export const addNewProject = project => post(url.ADD_NEW_PROJECT, project);

export const addReferances = event => post(`https://adminoy.oyliyo.com.tr:9654/postReferancesMega/send/`, event);

export const updateReferances = user => patch(`https://adminoy.oyliyo.com.tr:9654/patchReferancesMega/${user.ID}`, user);

export const getSubProject = (ID = "") => get(`https://adminoy.oyliyo.com.tr:9654/getProjectSubItem/select/${ID}`);

export const getTeacherWorkshop = () => get(`https://adminoy.oyliyo.com.tr:9654/getTeacherWorkshopMega/select/`);

export const addLessonsTime = event => post(`https://adminoy.oyliyo.com.tr:9654/postLessonsTimeMega/send/`, event);

export const updateLessonsTime = user => patch(`https://adminoy.oyliyo.com.tr:9654/patchTeacherWorkshopMega/${user.ID}`, user);

export const getClassAttendance = () => get(`https://adminoy.oyliyo.com.tr:9654/getClassAttendanceMega/select/`);

export const getClassesMega = () => get(`https://adminoy.oyliyo.com.tr:9654/getClassesMega/select/`);

export const getDynamicFormExtraMega = (ID = "") => get(`https://adminoy.oyliyo.com.tr:9654/getDynamicFormExtraMega/select/${ID}`);

export const getDynamicFormExtraExtraMega = (ID = "") => get(`https://adminoy.oyliyo.com.tr:9654/getDynamicFormExtraExtraMega/select/${ID}`);


export const addGallerry = job => post(`https://adminoy.oyliyo.com.tr:9654/postGalleryMega/send`, job);

export const addMultipleGalleryForm = job => post(`https://adminoy.oyliyo.com.tr:9654/postGalleryMultipleMega/send`, job);


export const deleteDynamicFormExtraExtra = project =>
  del(`https://adminoy.oyliyo.com.tr:9654/deleteDynamicExtraExtraFormMega/${project}`);


export const deleteDynamicFormExtra = project =>
  del(`https://adminoy.oyliyo.com.tr:9654/deleteDynamicFormExtraMega/${project}`);

export const deleteCourseSchedules = project =>
  del(`https://adminoy.oyliyo.com.tr:9654/deleteCourseSchedulesMega/${project}`);

export const deleteGallery = project =>
  del(`https://adminoy.oyliyo.com.tr:9654/deleteGalleryMega/${project}`);

export const deleteReferances = project =>
  del(`https://adminoy.oyliyo.com.tr:9654/deleteReferancesMega/${project}`);

export const deletePopup = project =>
  del(`https://adminoy.oyliyo.com.tr:9654/deleteQuestionSubCategory/${project}`);
export const getPopup = () => get(`https://adminoy.oyliyo.com.tr:9654/getQuestionSubCategory/select/`);
export const updatePopup = user => patch(`https://adminoy.oyliyo.com.tr:9654/patchQuestionSubCategory/${user.ID}`, user);
export const addPopup = job => post(`https://adminoy.oyliyo.com.tr:9654/addQuestionSubCategory/send`, job);



  export const deleteSSS = project =>
  del(`https://adminoy.oyliyo.com.tr:9654/deleteSSSPort/${project}`);
  





export const deleteProduct = project =>
del(`https://adminoy.oyliyo.com.tr:9654/deleteProductLuxun/${project}`);

  export const deleteBlog = project =>
  del(`https://adminoy.oyliyo.com.tr:9654/deleteblogCastor/${project}`);


  
export const deleteMega = project =>
  del(`https://adminoy.oyliyo.com.tr:9654/deleteMega/${project}`);

export const deleteProject = project =>
  del(url.DELETE_PROJECT, { headers: { project } });

export const getUserProfile = () => get(url.GET_USER_PROFILE);

// get maillist
//update mail
export const updateMail = mail => put(url.UPDATE_MAIL, mail);

// get folderlist
export const selectFolders = () => get(url.SELECT_FOLDER);

// post messages
export const addMessage = message => post(url.ADD_MESSAGE, message);

// get dashboard charts data
export const getWeeklyData = () => get(url.GET_WEEKLY_DATA);
export const getYearlyData = () => get(url.GET_YEARLY_DATA);
export const getMonthlyData = () => get(url.GET_MONTHLY_DATA);

export const walletBalanceData = month =>
  get(`${url.GET_WALLET_DATA}/${month}`, { params: { month } });

export const getStatisticData = duration =>
  get(`${url.GET_STATISTICS_DATA}/${duration}`, { params: { duration } });

export const visitorData = duration =>
  get(`${url.GET_VISITOR_DATA}/${duration}`, { params: { duration } });

export const topSellingData = month =>
  get(`${url.TOP_SELLING_DATA}/${month}`, { params: { month } });

export const getEarningChartsData = month =>
  get(`${url.GET_EARNING_DATA}/${month}`, { params: { month } });

const getProductComents = () => get(url.GET_PRODUCT_COMMENTS);

const onLikeComment = (commentId, productId) => {
  return post(`${url.ON_LIKNE_COMMENT}/${productId}/${commentId}`, {
    params: { commentId, productId },
  });
};
const onLikeReply = (commentId, productId, replyId) => {
  return post(`${url.ON_LIKNE_COMMENT}/${productId}/${commentId}/${replyId}`, {
    params: { commentId, productId, replyId },
  });
};

const onAddReply = (commentId, productId, replyText) => {
  return post(`${url.ON_ADD_REPLY}/${productId}/${commentId}`, {
    params: { commentId, productId, replyText },
  });
};

const onAddComment = (productId, commentText) => {
  return post(`${url.ON_ADD_COMMENT}/${productId}`, {
    params: { productId, commentText },
  });
};

export {
  getLoggedInUser,
  isUserAuthenticated,
  postFakeRegister,
  postFakeLogin,
  postFakeProfile,
  postFakeForgetPwd,
  postJwtRegister,
  postJwtLogin,
  postJwtForgetPwd,
  postJwtProfile,
  getProductComents,
  onLikeComment,
  onLikeReply,
  onAddReply,
  onAddComment,
};